import { observer } from 'mobx-react-lite';
import { GearSix, StopCircle } from '@phosphor-icons/react';
import { useResolve } from '@/infrastructure/useResolve';
import { useT } from './useT';
import { TOKEN_SimulationStore } from './SimulationStore';

export const ProcessingView = observer(function ProcessingView() {
  const sim = useResolve(TOKEN_SimulationStore);
  const t = useT();
  if (!sim.isRunning) return null;
  const label =
    sim.phase === 'expanding-bom'
      ? t.processing.expandingBom
      : sim.phase === 'seeding-demand'
        ? t.processing.seedingDemand
        : sim.phase === 'simulating'
          ? t.processing.simulating
          : t.processing.running;
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-6 p-12">
      <GearSix weight="duotone" size={56} className="animate-spin text-amber-signal" />
      <div className="font-mono text-base font-bold tracking-widest text-steel-700 dark:text-steel-200">
        {label}…
      </div>
      <button
        type="button"
        onClick={sim.cancel}
        className="flex items-center gap-1 border border-steel-300 bg-white px-4 py-1.5 font-mono text-xs uppercase tracking-wider hover:bg-light-red hover:text-white dark:border-steel-700 dark:bg-steel-900"
      >
        <StopCircle weight="fill" size={14} />
        {t.processing.cancel}
      </button>
    </div>
  );
});
